import event from '@/utils/event'
import { InscribeContentType } from '@/utils/types/inscribe'

export default function useInscribe(contentType?: InscribeContentType) {
	const inscribe = (file: File) => {
		event.emit('inscribe-modal', { file: file, event: 'open', contentType })
	}

	const inscribeBulk = (files: File[]) => {
		event.emit('inscribe-modal', { files: files, event: 'open', contentType })
	}

	return { inscribe, inscribeBulk }
}
